import React from 'react';
import { useGameState } from '../../context/GameStateContext';
import CountdownOverlay from '../CountdownOverlay';
import styles from './GameContent.module.css';
import { MODE_STATUS_COMPONENTS } from './modeComponentMap';

const GameContent = () => {
  // Get game state from context - much simpler now!
  const { activeMode, gameData, showCountdown, isStarting, handleCountdownComplete } = useGameState();

  // Determine mode and status
  const mode = activeMode || 'solo';
  const status = gameData?.status || 'none';
  console.log('mode', mode)
  
  // Get the component to render based on mode and status
  const ModeMap = MODE_STATUS_COMPONENTS[mode];
  const ComponentToRender = ModeMap ? ModeMap[status] : null;

  // Show loading state while gameData is null (during mode switches or initial load)
  if (gameData === null) {
    return (
      <div className={styles.gameContentContainer}>
        <div className={styles.loadingContainer}>Loading...</div>
      </div>
    );
  }

  // If no component is found for this mode/status combination
  if (!ComponentToRender) {
    console.error(`No component found for mode: ${mode}, status: ${status}`);
    return (
      <div className={styles.gameContentContainer}>
        <div>Unknown mode or status: {mode} / {status}</div>
      </div>
    );
  }

  // Render the appropriate component
  return (
    <div className={styles.gameContentContainer}>
      {showCountdown ? (
        <CountdownOverlay 
          puzzle={gameData?.description || gameData}
          onCountdownComplete={handleCountdownComplete}
        />
      ) : isStarting ? (
        <div className={styles.loading}>Starting puzzle...</div>
      ) : (
        <ComponentToRender 
          gameData={gameData}
          // Remove all the callback props - components will use context directly
        />
      )}
    </div>
  );
};

export default GameContent;
